import styled from 'styled-components';

import { MediaQuery } from '../../../../../constants/Styles';

export const MenuContainer = styled.div`
  display: flex;

  & > div {
    padding-right: 15px;

    & > :last-child {
      border-radius: 15px;
    }
  }

  ${MediaQuery.XL_AND_DOWN} {
    & > div {
      padding-right: 5px;
    }
  }

  ${MediaQuery.L_AND_DOWN} {
    display: block;
    align-items: center;
    padding-top: 10px;

    & > div {
      min-height: 45px;
      padding-right: 0px;
      width: 100%;
    }
  }
`;
